interface Props {
  titulo: string;
  mensagem: string;
  erro: string | null;
  salvando: boolean;
  aoConfirmar: () => void;
  aoCancelar: () => void;
}

export default function ModalExcluir({
  titulo,
  mensagem,
  erro,
  salvando,
  aoConfirmar,
  aoCancelar,
}: Props) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center overflow-y-auto bg-black/40 p-4">
      <div className="animate-modal-pop w-full max-w-sm rounded-lg bg-white p-6">
        <div className="flex justify-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-danger-100 text-danger-600">
            <i className="ri-delete-bin-6-line text-2xl" />
          </span>
        </div>
        <h3 className="mt-4 text-center text-lg font-medium text-foreground-950">{titulo}</h3>
        <p className="mt-2 text-center text-sm text-secondary-500">{mensagem}</p>
        {erro && (
          <p className="mt-3 text-center text-sm text-danger-600" role="alert">
            {erro}
          </p>
        )}
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={aoCancelar}
            disabled={salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Voltar
          </button>
          <button
            type="button"
            onClick={aoConfirmar}
            disabled={salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-danger-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-danger-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {salvando ? 'Apagando…' : 'Apagar'}
          </button>
        </div>
      </div>
    </div>
  );
}